'use client'

import { Button, LogOutIcon } from '@payloadcms/ui'
import { useRouter } from 'next/navigation'
import { useState } from 'react'

export const LogoutButton: React.FC = () => {
  const router = useRouter()
  const [isLoggingOut, setIsLoggingOut] = useState(false)

  const handleLogout = async () => {
    setIsLoggingOut(true)
    try {
      const response = await fetch('/api/users/logout', {
        method: 'POST',
        credentials: 'include',
        headers: {
          'Content-Type': 'application/json',
        },
      })

      if (response.ok) {
        // Refresh the page to clear the session
        window.location.href = '/admin/login'
      } else {
        console.error('Logout failed:', response.statusText)
        setIsLoggingOut(false)
      }
    } catch (error) {
      console.error('Error during logout:', error)
      setIsLoggingOut(false)
    }
  }

  return (
    <Button
      onClick={handleLogout}
      disabled={isLoggingOut}
      buttonStyle="none"
      size="medium"
      margin={false}
      className="ml-4 flex items-center"
    >
      <LogOutIcon />
      <span className="ml-2 text-base font-medium">
        {isLoggingOut ? 'Logging out...' : 'Logout'}
      </span>
    </Button>
  )
}
